var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-horizontal"},[_c('Collapse',{attrs:{"buttonShow":{
    title: 'Mais filtros',
    icon: 'fas fa-arrow-alt-circle-down',
    type: 'info',
  },"buttonHide":{
    title: 'Menos filtros',
    icon: 'fas fa-arrow-alt-circle-up',
    type: 'warning',
  }}},[_vm._t("content-filter-horizontal")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }